import React, { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import GuestRoute from 'src/Navigation/GuestRoute';
import Teachr from '../Objects/models/Teachr';
import Client from "../Objects/models/Client";
import { AppBarProps } from '../Objects/interfaces/NavBarInterface';
import useTailwindBrand from '../Theme/useTailwindBrand';
import AppBar from "./AppBar/AppBar"

interface IndexAppProps extends AppBarProps {
    index?: number
    navBar?: AppBarProps
    class?: string
    component?: ReactNode
    teachr?: Teachr | Client
    theme?: 'light' | 'dark';
    window?: () => Window;
    children?: React.ReactElement<{ elevation?: number }>;
    target?: any
    isDeclarons?: boolean
    className?:string
}

function ElevationScroll(props: IndexAppProps) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });
    return children ? React.cloneElement(children, { elevation: trigger ? 4 : 0, }) : null;
}

const IndexApp = (props: IndexAppProps) => {
    const { classes } = useTailwindBrand();
    const navIndex = props.navBar?.index ?? props.index;
    return (
        <GuestRoute>
            <div className={`${props.class} ${classes.background} min-h-screen`}>
                <CssBaseline />
                <ElevationScroll {...props}>
                    <AppBar
                        index={navIndex}
                        theme={props.theme}
                        className={props?.className}
                        stepper={props?.stepper}
                        isDeclarons={props.isDeclarons}
                    />
                </ElevationScroll>
                {props.component}
            </div>
        </GuestRoute>
    );
};

export default IndexApp;